<template>
  <CRow>
    <CCol col="12" lg="12">
      <CCard>
        <CCardHeader>
          <CCol>
            <strong>{{ $lang.resource.crud.detail }}</strong>
            <back-to-list></back-to-list>
          </CCol>
        </CCardHeader>
        <CCardBody>
          <CTabs add-tab-classes="mt-1">
            <span @click="selected = 'ResourceView'">
              <CTab>
                <template slot="title">
                  {{ $lang.resource.crud.detail }}
                </template>
              </CTab>
            </span>
            <span @click="selected = 'ResourceResponse'">
              <CTab>
                <template slot="title">
                  {{ $lang.resource.crud.response }}
                </template>
              </CTab>
            </span>
            <span @click="selected = 'ResourceReport'">
              <CTab>
                <template slot="title">
                  {{ $lang.resource.crud.view_report }}
                </template>
              </CTab>
            </span>
          </CTabs>
          <component
              :is="selected"
              @changeSelected="getTab($event)"
              style="margin-top: 20px"
          ></component>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
import {Mixin} from "/src/mixins/index.js";
import ResourceView from "./tab/ResourceView";
import ResourceReport from "./tab/ResourceReport";
import ResourceResponse from "./tab/ResourceResponse";
import BackToList from "../backToList.vue";

export default {
  name: "RView",
  mixins: [Mixin],
  components: {
    ResourceView,
    ResourceReport,
    ResourceResponse,
    BackToList,
  },
  data() {
    return {
      tabs: ["ResourceView", "ResourceReport", "ResourceResponse"],
      selected: "ResourceView",
      testString: "124 photos in 22 photo albums",
      backToListFlag: false,
      userId: "",
    };
  },
  mounted() {
    self.userId = this.$route.params.ids;
    const testString = this.$router.history.current.path;
    // let pathString = this.getStringBetween(testString, "all", "view");
    //  let entity = pathString.replace("/", "");
    // localStorage.setItem("activeTab", entity);
    this.backToListFlag = this.getStringBetween(testString, "all", "view") !== 0;
  },
  methods: {
    backToList(userId) {
      if (userId != null) {
        this.$router.push({path: "/profile/all/" + this.$route.params.ids});
      }
    },

    getTab(tab) {
      let self = this;
      self.selected = tab;
    },
  },
};
</script>
<style>
div .error {
  color: red;
}

.hasError label {
  color: red;
}
</style>
